export default {
  estados: [],
  estado: null,
  pagination: {}
};
